import { Component, OnInit } from '@angular/core';
import { PagesizeType } from '../service/pagination/pagesize-type';
import { MenuStore } from '../../menus/service/menu.store';
import { Constants } from '../../shared/constants';
import { Observable } from 'rxjs/Observable';
import { Page } from '../../shared/models/page';
import { MatchingAgency } from '../models/matching-agency';
import { MatchingAgencyService } from '../../shared/matching-agency/matching-agency.service';

@Component({
  selector: 'pioneer-matching-agency',
  templateUrl: './matching-agency.component.html',
  styles: []
})
export class MatchingAgencyComponent implements OnInit {

  pagesizeType = PagesizeType.MATCHING_AGENCY;

  currentPage: number;

  constructor(
    private matchingAgencyService: MatchingAgencyService,
    private menuStore: MenuStore) {
  }

  ngOnInit() {
    this.menuStore.setPageHeader('EVENT.AGENCY_REVIEW.LIST_PAGE_TITLE', false);
    this.currentPage = Constants.SEARCH_DEFAULT_PAGE;
  }

  get agenciesPresent(): Observable<boolean> {
    return this.agencyCount.map(agencyCount => {
      return agencyCount > 0;
    });
  }

  get agencyCount(): Observable<number> {
    return this.matchingAgencyService.totalAgencyCount;
  }

  onRefreshList(page: number, field?: string, direction?: string) {
    this.currentPage = page;
    this.matchingAgencyService
      .refreshMatchingAgencies(page, field, direction)
      .take(1).subscribe();
  }

  get agencies(): Observable<Page<MatchingAgency>> {
    return this.matchingAgencyService.agencies;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/matching-agency/matching-agency.component.ts